import { render, staticRenderFns } from "./systemNotification.vue?vue&type=template&id=daa73596&scoped=true"
import script from "./systemNotification.vue?vue&type=script&lang=js"
export * from "./systemNotification.vue?vue&type=script&lang=js"
import style0 from "./systemNotification.vue?vue&type=style&index=0&id=daa73596&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa73596",
  null
  
)

export default component.exports